import { FetchError } from '@atlassian/conversation-assistant-utils/httpUtils';

import { StreamErrorException } from './error-classes/StreamErrorException';
import { StreamGeneratorError } from './error-classes/StreamGeneratorError';

/** Only a reconnect GET's HTTP 404 or the explicit missing-replay SSE error is eligible. */
export const isExpiredReplayError = (error: unknown, acquisitionError: unknown): boolean => {
	if (error instanceof StreamErrorException) {
		return (
			error.detail.type === 'ERROR' &&
			error.detail.message.status_code === 404 &&
			error.detail.message.content.trim() === 'Message not found'
		);
	}
	// A required action or handler may also throw FetchError. Only accept the exact
	// failure recorded at the reconnect acquisition boundary, including its reader wrapper.
	const cause = error instanceof StreamGeneratorError ? error.cause : error;
	return (
		cause === acquisitionError &&
		acquisitionError instanceof FetchError &&
		acquisitionError.errorAttributes.statusCode === 404
	);
};
